import React, { useState } from "react";
import FilterIcon from "../assets/Icons/FilterIcon";  // Your SVG icon component
import UpArrowIcon from "../assets/Icons/UpArrowIcon"; // Your SVG icon component
import "../css/FilterCompoent.css";

const FilterCompoent = ({
  showFilters,
  setShowFilters,
  filters,
  inputValues,
  onFilterChange,
  onInputChange,
}) => {
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    onFilterChange(id, checked);
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    const key = id.replace("-input", "");

    // Automatically check the corresponding checkbox when the user types in the input
    if (["name", "mobile", "email"].includes(key) && value.length > 0 && !filters[key]) {
      onFilterChange(key, true);
    }

    onInputChange(key, value);
  };

  return (
    <div className="filter-container">
      <button
        className="filter-toggle"
        onClick={() => setShowFilters((prev) => !prev)}
        aria-expanded={showFilters}
        aria-controls="filter-dropdown"
      >
        <span className="filter-icon">
          <FilterIcon fill="#EBA8BF" />
        </span>
        <span className="filter-text">Filters</span>
        <span className={`arrow-icon ${showFilters ? "rotate" : ""}`}>
          <UpArrowIcon fill="#EBA8BF" />
        </span>
      </button>

      {showFilters && (
        <div
          className="filter-dropdown"
          id="filter-dropdown"
          role="region"
          aria-label="Filter options"
        >
          <button className="filter-toggle-inner" onClick={() => setShowFilters(false)}>
            <span className="filter-icon">
              <FilterIcon fill="#EBA8BF" />
            </span>
            <span className="filter-text">Filters</span>
            <span className={`arrow-icon ${showFilters ? "rotate" : ""}`}>
              <UpArrowIcon fill="#EBA8BF" />
            </span>
          </button>

          <div className="checkbox-group">
            {["name", "mobile", "email", "subscribed", "unsubscribed"].map((filter) => (
              <div key={filter} className="filter-group">
                <label htmlFor={filter}>
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                  <input
                    type="checkbox"
                    id={filter}
                    checked={filters[filter]}
                    onChange={handleCheckboxChange}
                  />
                </label>

                {["name", "mobile", "email"].includes(filter) && (
                  <input
                    type="text"
                    id={`${filter}-input`}
                    placeholder={`Search ${filter}`}
                    className="filter-text-input"
                    value={inputValues[filter]}
                    onChange={handleInputChange}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterCompoent;